(function () {
  // ES5 — IE11 and other older browsers must parse this file.
  // If it throws a syntax error, the appointment product falls through
  // to Shopify Add to Cart / checkout (the payment page).

  function docReady(fn) {
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      setTimeout(fn, 1);
    } else if (document.addEventListener) {
      document.addEventListener("DOMContentLoaded", fn);
    } else if (document.attachEvent) {
      document.attachEvent("onreadystatechange", function () {
        if (document.readyState === "complete") fn();
      });
    }
  }

  function textOf(el) {
    return ((el && (el.textContent || el.innerText)) || "").toLowerCase();
  }

  function findAddToCartButton(addToCartSelector) {
    var atcButton = null;
    var i;
    var btn;
    var form;
    var allCartForms;
    var buttons;

    if (addToCartSelector) {
      atcButton = document.querySelector(addToCartSelector);
    }

    if (!atcButton) {
      allCartForms = document.querySelectorAll('form[action*="cart"]');
      for (i = 0; i < allCartForms.length; i++) {
        form = allCartForms[i];
        btn = form.querySelector(
          'button[type="submit"], input[type="submit"]'
        );
        if (btn) atcButton = btn;
      }
    }

    if (!atcButton) {
      buttons = document.querySelectorAll("button");
      for (i = 0; i < buttons.length; i++) {
        btn = buttons[i];
        if (
          textOf(btn).indexOf("add to cart") !== -1 &&
          (!btn.classList || !btn.classList.contains("no-js"))
        ) {
          atcButton = btn;
        }
      }
    }

    if (!atcButton) {
      buttons = document.querySelectorAll("button");
      for (i = 0; i < buttons.length; i++) {
        btn = buttons[i];
        if (
          textOf(btn).indexOf("add to basket") !== -1 &&
          (!btn.classList || !btn.classList.contains("no-js"))
        ) {
          atcButton = btn;
        }
      }
    }

    return atcButton;
  }

  function findBuyNowButton(selector) {
    var foundButton = selector ? document.querySelector(selector) : null;
    var buttons;
    var i;
    var btn;

    if (!foundButton) {
      buttons = document.querySelectorAll("button");
      for (i = 0; i < buttons.length; i++) {
        btn = buttons[i];
        if (
          textOf(btn).indexOf("buy now") !== -1 &&
          (!btn.classList || !btn.classList.contains("no-js"))
        ) {
          foundButton = btn;
        }
      }
    }

    if (!foundButton) {
      buttons = document.querySelectorAll("button");
      for (i = 0; i < buttons.length; i++) {
        btn = buttons[i];
        if (
          textOf(btn).indexOf("buy it now") !== -1 &&
          (!btn.classList || !btn.classList.contains("no-js"))
        ) {
          foundButton = btn;
        }
      }
    }

    if (!foundButton) {
      foundButton = document.querySelector(".shopify-payment-button");
    }

    return foundButton;
  }

  function getJson(url, cb) {
    if (window.fetch) {
      fetch(url)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          cb(null, data);
        })
        .catch(function (err) {
          cb(err);
        });
      return;
    }
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          cb(null, JSON.parse(xhr.responseText));
        } catch (errParse) {
          cb(errParse);
        }
      } else {
        cb(new Error("Servicify HTTP " + xhr.status));
      }
    };
    xhr.onerror = function () {
      cb(new Error("Servicify network error"));
    };
    xhr.send();
  }

  function hidePaymentUi(addToCartButton) {
    addToCartButton.setAttribute(
      "data-original-text",
      addToCartButton.innerText || addToCartButton.textContent || ""
    );
    addToCartButton.setAttribute("disabled", true);
    addToCartButton.setAttribute("data-servicify-atc", true);
    if ("innerText" in addToCartButton) {
      addToCartButton.innerText = "Loading Available Slots";
    } else {
      addToCartButton.textContent = "Loading Available Slots";
    }

    var buyNowButton = findBuyNowButton();
    if (buyNowButton && buyNowButton.style) {
      buyNowButton.style.display = "none";
    }
  }

  docReady(function () {
    function changeButtons() {
      var addToCartButton = findAddToCartButton();
      var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
      var url = null;

      if (!addToCartButton) {
        window.SERVICIFY_HAS_UPDATED_BUTTON = true;
        return;
      }

      if (meta.product && meta.product.id) {
        url =
          "https://servicify-appointments.herokuapp.com/api/products/" +
          meta.product.id +
          "/events?variantId=" +
          (meta.selectedVariantId || "");
      } else if (meta.selectedVariantId) {
        url =
          "https://servicify-appointments.herokuapp.com/api/variants/" +
          meta.selectedVariantId +
          "/events";
      }

      if (!url) {
        window.SERVICIFY_HAS_UPDATED_BUTTON = true;
        return;
      }

      getJson(url, function (err, data) {
        try {
          if (!err && data && data.isActive) {
            hidePaymentUi(addToCartButton);
          }
        } catch (errInner) {}
        window.SERVICIFY_HAS_UPDATED_BUTTON = true;
      });
    }

    try {
      changeButtons();
    } catch (err) {
      window.SERVICIFY_HAS_UPDATED_BUTTON = true;
    }
  });
})();
